// config/index.tsx

import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { Chain, holesky, hoodi, mainnet } from '@reown/appkit/networks';
import {
  cookieStorage,
  createStorage,
  fallback,
  http,
  webSocket,
} from '@wagmi/core';
import invariant from 'invariant';
import { isProductionLike } from './constants/env';

// Get projectId from https://cloud.reown.com
export const projectId = process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID!;

invariant(projectId, 'Project ID is not defined');

export const networks: Chain[] = [mainnet];

if (!isProductionLike) {
  networks.push(holesky, hoodi);
}

//Set up the Wagmi Adapter (Config)
export const wagmiAdapter = new WagmiAdapter({
  storage: createStorage({
    storage: cookieStorage,
  }),
  ssr: true,
  projectId,
  networks,
  transports: {
    [mainnet.id]: fallback([
      webSocket(
        'wss://eth.w3node.com/8a42ea54adcd1f4dff0d01b69b7f5c90e638514fc44aedd777c033bb08fa1b61/ws'
      ),
      http(
        'https://eth.w3node.com/8a42ea54adcd1f4dff0d01b69b7f5c90e638514fc44aedd777c033bb08fa1b61/api'
      ),
    ]),
    [hoodi.id]: http(
      'https://hoodi-eth.w3node.com/75f7e360c3b8caab9ccaf76572735de4df004526b270f98df0142744a987e037/api'
    ),
  },
});

export const config = wagmiAdapter.wagmiConfig;
